import React from 'react';
import { View } from 'react-native';
import type { Meta, StoryObj } from '@storybook/react';

import { ChallengeCalendar, ChallengeDay } from './ChallengeCalendar';

// days computed relative to now so today's chip always shows in-week; only
// the printed dates move, the layout stays stable
const DAY_MS = 24 * 60 * 60 * 1000;
const day = (offsetFromToday: number, done: boolean, entry?: string): ChallengeDay => ({
  done,
  maxDate: new Date(Date.now() + (offsetFromToday + 1) * DAY_MS).toISOString(),
  dateOfCompletion: done ? new Date(Date.now() + offsetFromToday * DAY_MS).toISOString() : null,
  entry: entry || null,
});

const MID_CHALLENGE: ChallengeDay[] = [
  day(-2, true, 'How are you today?\nVery good\n\nWhat are you grateful for today?\nA calm morning walk before work.'),
  day(-1, true, 'How are you today?\nOkay\n\nWhat are you grateful for today?\nDinner with an old friend.'),
  day(0, false),
  day(1, false),
  day(2, false),
  day(3, false),
  day(4, false),
];

const meta = {
  title: 'Challenges/ChallengeCalendar',
  component: ChallengeCalendar,
  args: {
    days: MID_CHALLENGE,
    showEntry: true,
    onPressCompleteToday: () => undefined,
  },
  decorators: [
    Story => (
      <View style={{ width: 360 }}>
        <Story />
      </View>
    ),
  ],
} satisfies Meta<typeof ChallengeCalendar>;

export default meta;

type Story = StoryObj<typeof meta>;

export const MidChallenge: Story = {};

export const FirstDay: Story = {
  args: {
    days: [day(0, false), day(1, false), day(2, false), day(3, false), day(4, false), day(5, false), day(6, false)],
  },
};

export const MemoChallenge: Story = {
  // memo decks are identical every day: their calendar hides the entry card
  args: { showEntry: false },
};
